import React from 'react';
const MailBoxSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-mailbox" });
MailBoxSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-mailbox sirius-icon-mailbox-enhance" });
export default MailBoxSvg;
